export default __webpack_public_path__ + "static/media/arrow-order.f08f7154.svg";